import { Outlet, Link } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from './Navigation';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.manila};
`;

const Header = styled.header`
  text-align: center;
  padding: 2rem 2rem 1rem 2rem;
  background: linear-gradient(to bottom, #F5EFE3 0%, #FAF3E8 100%);
  border-bottom: 2px solid #C4B5A0;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 1.5rem 1rem 0.75rem 1rem;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.ink};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 4px;
  text-shadow: 2px 2px 0px rgba(255, 255, 255, 0.5);

  @media (max-width: 768px) {
    font-size: 2rem;
    letter-spacing: 2px;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    letter-spacing: 1px;
  }
`;

const Subtitle = styled.p`
  margin: 0.5rem 0 0 0;
  font-size: 0.9rem;
  letter-spacing: 2px;
  color: #8A7E70;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    letter-spacing: 1px;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
    letter-spacing: 0.5px;
  }
`;

const ContentArea = styled.main`
  flex: 1;
  background: #FAF3E8;
  border-top: 1.5px solid #C4B5A0;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.05);
`;

const Footer = styled.footer`
  padding: 1.5rem;
  text-align: center;
  background: transparent;
  margin-top: auto;
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.brownDark};
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  padding: 0.5rem;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  
  &:hover {
    text-decoration: underline;
    opacity: 1;
    color: ${({ theme }) => theme.colors.ink};
  }
`;

const MainLayout = () => {
  return (
    <AppContainer>
      <Header>
        <Title>Epstein Archive</Title>
        <Subtitle>Document Archive</Subtitle>
      </Header>
      <Navigation />
      <ContentArea>
        <Outlet />
      </ContentArea>
      <Footer>
        <FooterLink to="/disclaimer">Methodology & Disclaimer</FooterLink>
      </Footer>
    </AppContainer>
  );
};

export default MainLayout;
